var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isStatusOk)?_c('global-response-status',{on:{"primaryErrorButtonFunction":_vm.retryPageMetrics}}):_c('div',{staticClass:"container no-padding"},[_c('metrics'),_vm._v(" "),_c('chart',{attrs:{"pageIdentifier":_vm.pageIdentifier}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35dd4bbc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/screens/Metrics/components/Main.vue
// module id = 1472
// module chunks = 1